import { redirect, type LoaderFunctionArgs } from 'react-router';
import { adresseDeRetour, parametresEtFragment } from '../../auth/retour.js';
import { exigerSession } from '../loaders.js';

/** Un seul segment de lettres et de tirets : jamais un chemin, jamais un hôte. */
const SECTION = /^[a-z]+(?:-[a-z]+)*$/;

/**
 * `/` : renvoie vers la première galerie OUVERTE du compte. Un membre dont
 * toutes les galeries sont résiliées n'a plus de régie : seulement la page
 * « Archive de votre galerie », jusqu'à la purge (ARTO-54). Sans galerie du
 * tout : `/connexion`.
 *
 * `/?aller=oeuvres` : même renvoi, vers cette section de la galerie. C'est
 * l'adresse des raccourcis du manifeste, qui ne connaît pas le slug.
 */
export async function racineLoader({ request }: LoaderFunctionArgs): Promise<never> {
  const session = await exigerSession(adresseDeRetour(request.url));
  const fermee = (etat: string | null): boolean =>
    etat === 'resiliee' || etat === 'purge_en_cours' || etat === 'purgee';
  const ouverte = session.galeries.find((galerie) => galerie.slug && !fermee(galerie.etat));
  // Les paramètres (`?design=`, `?lang=`, `?demo=`…) et le fragment suivent.
  if (ouverte?.slug) {
    const url = new URL(request.url);
    const section = url.searchParams.get('aller');
    url.searchParams.delete('aller');
    const suite = section === null ? parametresEtFragment(request.url) : url.search + url.hash;
    const cible = section !== null && SECTION.test(section) ? `/${section}` : '';
    throw redirect(`/${ouverte.slug}${cible}${suite}`);
  }
  throw redirect(session.galeries.length > 0 ? '/archive' : '/connexion');
}
